import { useEffect, useState } from "react";
import { ArrowDown, ArrowUp } from "lucide-react";

// Lote 108 (Robson, 24/10/2026): botão flutuante só no celular para ir ao topo (quando a página já
// rolou) ou ao fim (quando está no topo de uma página longa) — na zona do polegar, acima do balão do Chat.
export default function ScrollPagina() {
  const [estado, setEstado] = useState(null); // "topo" (mostra seta p/ cima) | "fim" (seta p/ baixo) | null
  useEffect(() => {
    // O Layout usa min-h-screen: quem rola é a janela (e, por garantia, o <main>).
    const main = document.querySelector("main");
    const calc = () => {
      const de = document.documentElement;
      const y = Math.max(window.scrollY || 0, de.scrollTop || 0, main?.scrollTop || 0);
      const alt = Math.max(de.scrollHeight, main?.scrollHeight || 0);
      const longa = alt > window.innerHeight * 1.8;
      if (y > 300) setEstado("topo");
      else if (longa && y < 100) setEstado("fim");
      else setEstado(null);
    };
    calc();
    window.addEventListener("scroll", calc, { passive: true });
    main?.addEventListener("scroll", calc, { passive: true });
    const t = setInterval(calc, 1500);   // páginas que carregam depois (listas) mudam a altura
    return () => { window.removeEventListener("scroll", calc); main?.removeEventListener("scroll", calc); clearInterval(t); };
  }, []);
  if (!estado) return null;
  const subir = estado === "topo";
  return (
    <button
      type="button"
      data-testid="scroll-pagina"
      aria-label={subir ? "Voltar ao topo" : "Ir ao fim da página"}
      onClick={() => {
        const main = document.querySelector("main");
        const top = subir ? 0 : Math.max(document.documentElement.scrollHeight, main?.scrollHeight || 0);
        window.scrollTo({ top, behavior: "smooth" });
        if (main && main.scrollTop) main.scrollTo({ top, behavior: "smooth" });
      }}
      className="md:hidden fixed z-30 right-4 bottom-[158px] h-11 w-11 rounded-full bg-white/95 text-stone-700 border border-stone-300 shadow-md inline-flex items-center justify-center"
    >
      {subir ? <ArrowUp className="h-5 w-5" /> : <ArrowDown className="h-5 w-5" />}
    </button>
  );
}
